export default __webpack_public_path__ + "static/IMDEX Asia-ce4b546ca085f8e8b9b5addecdb4b285.png";